import { Component, OnInit, ViewChild,NO_ERRORS_SCHEMA } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { UserPost } from '../model/user';
import { UserService } from '../service/user.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { AuthServiceService } from 'app/component/service/auth-service.service';

@Component({
  selector: 'app-user-post',
  templateUrl: './user-post.component.html',
  styleUrls: ['./user-post.component.css']
})
export class UserPostComponent implements OnInit {
  name = 'ng2-ckeditor';
  ckeConfig: any;
  mycontent: string;
  log: string = '';
  AppointmentDoctorId:string='0';
  Users:Array<any>= [];
  srvData : UserPost = new UserPost(null,'','',null,'','','','I');
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  isAdd  : boolean = true; 
  UserPosts : UserPost[];
  selectedObject : UserPost;
  user:any;
  filesData: any[];
  text : string;
  profilePic : any;
  isSuperAdmin = false;
  constructor(private _sharedService: SharedService, private _usrService : UserService, private authService:AuthServiceService) { 
    this.isAdd= true;
    
        this.mycontent = `<p>My html content</p>`;
  }

 
  getUserPostDetail() : void {
    if(this.AppointmentDoctorId==='0') {
      this.listLoading = true;
      this._usrService.getUserPost().subscribe(
        data=>{
            this.listLoading = false;
            this.UserPosts  = data;
        },
        error=>{}
      );
    } else {
      this.listLoading = true;
      this._usrService.getUserPostData(parseInt(this.AppointmentDoctorId)).subscribe(
        data=>{
            this.listLoading = false;
            this.UserPosts  = data;
        },
        error=>{}
      );
    }
    
  }
  getUsers() : void { 
    this._usrService.getUsersDetail().subscribe( data=> {
     
      this.Users = data;//.filter((usr) => usr.UserRoleId < 3 ) 
    },
    error=>{ 
    });
  }
  clearData() : void {
        this.srvData.PostId= null;
        this.srvData.HeaderText="";
        this.srvData.Text= "";
        this.srvData.ImagePath= ""; 
        this.srvData.VideoPath= "";
        this.srvData.Type= "Y";
        this.isAdd= true;
        this.profilePic="";
        this.text="";
  }
   
  cancelData() : void {
     if(this.isAdd) {
       this.clearData();
     } else {
       this._sharedService.emitDialog(true,"Cancel",ActionMessage.CANCEL.toString(),true, DialogAction.CANCEL.toString(),'ACTION' );
     }
       
  }
  editUserPost(srvEditObject : UserPost) : void {
     this.isAdd = false;
     this.srvData = Object.assign(Object.create(srvEditObject), srvEditObject);
    
  }
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    this.ckeConfig = {
      allowedContent: false,
      extraPlugins: 'divarea',
      forcePasteAsPlainText: true
    };
    this.getUsers();
    this.getUserPostDetail(); 
    this._sharedService.yesEmitted$.subscribe(
      text => {
          if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'ACTION') {
              this.delete();
          } else {
              this.clearData();
          }
      });

      this.getUsers();
      if(this.authService.getUserRole() === "1") {
        this.isSuperAdmin = true;
     }  
  }

  loadUserPost() {
    this.getUserPostDetail(); 
  }
  saveUserPost() : void {
      this.loading = true;
      this._usrService.dataPost = this.srvData;
      if(this.isAdd){
        this._usrService.dataPost.UserId =parseInt(this.AppointmentDoctorId);
        
        this.addUserPost();
      } else {
        this.updateUserPost();
      }
  }
  updateProfilePic(id : number,userid : number, bookingNumber: string) {
    this._usrService.dataPost.PostId = id;
    this._usrService.dataPost.UserId = userid;
    this.filesData = [];

    this.filesData.push(this.profilePic );
    this._usrService.profilePic = this.filesData;
    this._usrService.savePostPic().subscribe(data=>{
      this.loading = false;
      this.profilePic = null;
      this.text = '';
      this.clearData();
      this.getUserPostDetail();
    },
    error=>{
        this.loading = false;
        if(JSON.parse(error._body).Message===undefined){
          this.message = error._body;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        this.clearData();
        this.getUserPostDetail();
    });
  }
  addUserPost() :void { 
       this._usrService.saveUserPost().subscribe(data=>{
        this.loading = false;
        this.message = "User Post "+ ActionMessage.SAVESUCCESS.toString();
       
        if(this.profilePic != undefined) {
          this.updateProfilePic(data.PostId,data.UserId, "");
        } else {
          this.getUserPostDetail();
          this.clearData();
        }
        this.hideMessage();
      },
      error=>{
          this.loading = false;
           if(error.data !== undefined) {             this.message = error.data;           } else {             this.message = JSON.parse(error._body).Message;           }
           this.hideMessage();
      });
    }
  updateUserPost() :void {
     
      this._usrService.updateUserPost().subscribe(data=>{
        this.loading = false;
        this.message = "User Post "+ ActionMessage.UPDATESUCCESS.toString();
       
        if(this.profilePic != undefined) {
          this.updateProfilePic(this.srvData.PostId,this.srvData.UserId, "");
          
        } else {
          this.getUserPostDetail();
          this.clearData();
        }
        
        this.hideMessage();
      },
      error=>{
          this.loading = false;
           if(error.data !== undefined) {             this.message = error.data;           } else {             this.message = JSON.parse(error._body).Message;           }
           this.hideMessage();
       });
        
  } 
  deleteImage(data: UserPost) {
    this.srvData.ImagePath = "";
    this._usrService.dataPost = this.srvData;
    this.updateUserPost();
  }
  hideMessage() : void {
    setTimeout(() => {
      this.message = '';
    }, 1000);
  }
  delete() :void {
      this.listLoading = true;
      this._usrService.deleteUserPost(this.selectedObject).subscribe(data=>{
        this.listLoading = false;
        this.message = "User Post " + ActionMessage.DELETESUCCESS.toString();
        this.clearData();
        this.getUserPostDetail();
        this.hideMessage();
      },
      error=>{
          this.listLoading = false;
           if(error.data !== undefined) {             this.message = error.data;           } else {             this.message = JSON.parse(error._body).Message;           }
        this.hideMessage();
      });
  }
  onChangeFile(event: EventTarget) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext> event;
    let target: HTMLInputElement = <HTMLInputElement> eventObj.target;
    let files: FileList = target.files;
    this.profilePic = files[0];
    this.text = files[0].name;
    
  }
  deletUserPost(org : UserPost) :void {
    this.selectedObject = org;
    this._sharedService.emitDialog(true,"Delete",ActionMessage.DELETE.toString(),true,DialogAction.DELETE.toString(),'ACTION' );      
  }
  ngAfterViewChecked() {
     this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
     this._sharedService.emitChange(true);
  }
  onChange($event: any): void {
    console.log("onChange");
    //this.log += new Date() + "<br />";
  }

}



// WEBPACK FOOTER //
// ./src/app/section/user/user-post/user-post.component.ts